import dayjs from 'dayjs';
import { atomWithReset } from 'jotai/utils';

// ─── Tipos ────────────────────────────────────────────────────────────────────

/**
 * Filtros aplicados na Biblioteca de Questões.
 * Escopo de feature — não exportar fora da feature.
 *
 * Os campos de ID (disciplineId, personId, companyId, componentType) mapeiam
 * diretamente para os parâmetros da API `GetApiV1ExamQuestionLibraryQueryParams`.
 */
export interface QuestionFilters {
  /** ID da disciplina (API: DisciplineId) */
  readonly disciplineId: number | null;
  /** ID do autor/pessoa (API: PersonId) */
  readonly personId: number | null;
  /** ID da empresa (API: CompanyId) */
  readonly companyId: number | null;
  /** Tipo de componente (API: ComponentType) */
  readonly componentType: number | null;
  /** Idioma da questão, ex: "pt-BR" (API: CulturesInfo) */
  readonly cultureInfo: string | null;
  /** Data de início no formato YYYY-MM-DD (API: StartDate) */
  readonly startDate: string;
  /** Data de fim no formato YYYY-MM-DD (API: EndDate) */
  readonly endDate: string;
  /** Texto de busca pelo enunciado (API: LabelSearch) */
  readonly labelSearch: string;
  /** Página atual (API: PageNumber) */
  readonly page: number;
}

const defaultQuestionFilters: QuestionFilters = {
  disciplineId: null,
  personId: null,
  companyId: null,
  componentType: null,
  cultureInfo: 'pt-BR',
  startDate: dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
  endDate: dayjs().add(1, 'month').format('YYYY-MM-DD'),
  labelSearch: '',
  page: 1,
};

// ─── Átomos ───────────────────────────────────────────────────────────────────

/**
 * Átomo de filtros da Biblioteca de Questões.
 * Use `atomWithReset` para permitir reset ao estado inicial via `RESET`.
 */
export const questionFiltersAtom = atomWithReset<QuestionFilters>(defaultQuestionFilters);
